import { render, staticRenderFns } from "./xwxq.vue?vue&type=template&id=5432b0aa&scoped=true"
import script from "./xwxq.vue?vue&type=script&lang=js"
export * from "./xwxq.vue?vue&type=script&lang=js"
import style0 from "./xwxq.vue?vue&type=style&index=0&id=5432b0aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5432b0aa",
  null
  
)

export default component.exports